// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3gHaZ","productName":"Table_productName__OXOUD"};